import { CONTRACTOR_COMMENTS_URL, SPECIALISTS_URL } from "api/routes";
import { noAuthInstance } from "hooks/useRequest/helper";
import { IGetCommentsResponse } from "rules/interface/api/comments/get-comments.interface";
import { IApiRequestPagination, IApiRequestParams, IServerGetResponse } from "rules/interface/api/response";
import { IContractor } from "rules/interface/contractor/contractor.interface";
import IContractorListMeta from "rules/interface/contractor/list-meta.interface";
import IContractorListParams from "rules/interface/contractor/list-params.interface";


export const getContractorComments = async ({ params }: IApiRequestParams<{}>): Promise<IServerGetResponse<IGetCommentsResponse[]>> => {
    return await noAuthInstance
        .get(CONTRACTOR_COMMENTS_URL, { params })
        .then((res) => res.data);
};


export const getContractors = async ({ params }: IApiRequestParams<IContractorListParams & IApiRequestPagination>): Promise<IServerGetResponse<IContractor[], IContractorListMeta>> => {

    params.sortBaseOn = params.sortBaseOn ?? "usersRecommendation"

    return await noAuthInstance
        .get(SPECIALISTS_URL, { params })
        .then((res) => res.data);
};